// Static list of content aggregators shown in the "Aggregator" filter.
// There is no programmatic source for these names, and each is matched against
// merchant (celebrityName) with its own rule on the backend — see
// AGGREGATOR_MATCH_CLAUSES in supabase functions/products-search-v3. Keep these
// `value`s in sync with the keys of that map.
export const aggregators = [
  { label: 'Withlocals', value: 'Withlocals' },
  { label: 'Fever', value: 'Fever' },
  { label: 'Viator', value: 'Viator' },
  { label: 'Toristy', value: 'Toristy' },
];
